import React from 'react';
import CustomServiceLayout from 'layouts/CustomServiceLayout';
import Types from 'components/CustomService/Types';

export default function CustomServicesPage() {
  return (
    <CustomServiceLayout>
      <Types />
    </CustomServiceLayout>
  );
}
